import { render, staticRenderFns } from "./Frequencies.vue?vue&type=template&id=4e1e4f89&scoped=true&"
import script from "./Frequencies.vue?vue&type=script&lang=js&"
export * from "./Frequencies.vue?vue&type=script&lang=js&"
import style0 from "./Frequencies.vue?vue&type=style&index=0&id=4e1e4f89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1e4f89",
  null
  
)

/* custom blocks */
import block0 from "./Frequencies.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports